import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "clone-modal" */'./CloneModal').then(mod => mod.default),
  LoadingComponent: () => null
});